import type { Flag } from "./types";

export function FlagRow({
  flag,
  onToggle,
}: {
  flag: Flag;
  onToggle: (flag: Flag) => void;
}) {
  return (
    <button
      type="button"
      className={`dt-feature-flags__row ${flag.overridden ? "dt-feature-flags__row--overridden" : ""}`}
      onClick={() => onToggle(flag)}
    >
      <div className="dt-feature-flags__row-info">
        <div className="dt-feature-flags__row-name">
          {flag.overridden && "✓ "}
          {flag.name}
        </div>
        {flag.overridden && (
          <div className="dt-feature-flags__row-detail">
            default: {flag.default ? "on" : "off"}
          </div>
        )}
      </div>
      <div
        className={`dt-feature-flags__toggle ${flag.active ? "dt-feature-flags__toggle--on" : ""}`}
      >
        <div className="dt-feature-flags__toggle-track">
          <div className="dt-feature-flags__toggle-thumb" />
        </div>
      </div>
    </button>
  );
}
